import { Stack } from '@mui/material';

import { styled } from '@/theme/styled';

const Container = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2),
  flexDirection: 'row',
  maxWidth: 300,
  overflow: 'hidden',
}));

export { Container };
